import React from 'react';
import PropTypes from 'prop-types';
import { Button, ProgressCircular } from '@americanexpress/dls-react';
import { FormattedMessage } from 'react-intl';
import { formatBytes } from '../../utils/util';

// Temp array to fetch only english locales until translations for all other markets are obtained
const Submit = ({
  submitDoc,
  sumOfDocs,
  isSubmitting,
  isSubmitDisabled,
  submitView,
  maxBatchSizeLabel,
}) => {
  switch (submitView) {
    case 'Disabled': return null;
    case 'ViewOne': return (
      <div
        className="flex flex-column flex-align-center width-full dnuk-submit-view-stack"
      >
        {/* First child - Total size label */}
        <div
          className="flex flex-align-start dls-white-bg width-full dnuk-submit-size-container"
        >
          <div
            tabIndex="0"
            id="sizeStatus"
            className="text-align-right width-full dnuk-submit-size-text"
          >
            <FormattedMessage id="totalSize" />
            <span
              className="font-weight-bold dls-grey-05"
            >
              <FormattedMessage
                id="totalSizeOf"
                values={{
                  maxSize: maxBatchSizeLabel,
                  fileSize: formatBytes(sumOfDocs),
                }}
              />
            </span>
          </div>
        </div>

        {/* Second child - empty spacer */}
        <div
          className="flex flex-column flex-align-center width-full dnuk-content-stack pad-2-b"
        />

        {/* Third child - Submit button with top border */}
        <div
          id="submitButton"
          className="flex flex-justify-end flex-align-center flex-align-self-stretch dls-white-bg width-full dnuk-submit-button-container"
        >
          {isSubmitting ? (
            <div className="action-groups">
              <span data-testid="submit-loader" className="flex flex-align-center">
                <ProgressCircular />
              </span>
            </div>
          ) : (
            <div className="action-groups">
              <Button tabIndex="0" type="button" variant="primary" onClick={submitDoc} id="btn-submit" disabled={isSubmitDisabled}>
                <FormattedMessage id="submitButton" />
              </Button>
            </div>
          )}
        </div>
      </div>
    );
    default: return (
      <footer className="row flex-justify-center margin-auto-lr pad-3-tb">
        {isSubmitting ? (
          <div className="action-groups">
            <span data-testid="submit-loader" className="flex flex-align-center">
              <ProgressCircular />
            </span>
          </div>
        ) : (
          <div className="action-groups">
            <Button tabIndex="0" className="text" variant="primary" onClick={submitDoc} id="btn-submit" disabled={isSubmitDisabled}>
              <FormattedMessage id="submitButton" />
            </Button>
          </div>
        )}
      </footer>
    );
  }
};

Submit.propTypes = {
  submitDoc: PropTypes.func.isRequired,
  sumOfDocs: PropTypes.number.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isSubmitDisabled: PropTypes.bool.isRequired,
  submitView: PropTypes.string.isRequired,
  maxBatchSizeLabel: PropTypes.string.isRequired,
};

export default Submit;
